module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Fridge-5bd43c311a28c396ca82ff780d823e23.svg";